"use strict";

var AccountFormHelper = require("./AccountFormHelper");

var PostalCodeHelper = {

	initialize: function (options) {
		this.options = options || {};
		this.postalCodeFormatWizard = options.postalCodeFormatWizard || {};

		document.addEventListener("DOMContentLoaded", () => {
			this.addCountryChangeListeners()
		});
	},
	// find the accountAddressPostalCode data-component in the body or parent selector
	addCountryChangeListeners: function (parentSelector) {
		var eventSearchPostalCodeSelectorText = "[data-component='textInput'][data-code-type='postalCode'] input";
		var $postalCodes = $(parentSelector || "body").find(`[data-component='accountAddressPostalCode'], ${eventSearchPostalCodeSelectorText}`);

		//For each element, get the country if available
		$postalCodes.each((index, postalCode) => {
			if (postalCode.hasAttribute("required")) {
				postalCode.setAttribute("isRequiredByDefault", "true");
			}

			var $country = AccountFormHelper.getParentForm(postalCode).find("[data-react-component-name='CountrySelector']");
			var isCountryAvailable = $country.length > 0;
			//If the country is available, call the addPostalCode validation when the country changes
			if (isCountryAvailable) {
				$country.on("change.postalCodeHelper", (event) => this.onCountryChange(event));
			}

			//If there currently is a country, apply the wizzard.  If not, get the default and apply the wizard.
			var countryCode = isCountryAvailable ? $country.children().val() : AccountFormHelper.getDefaultCountry();
			if (countryCode) {
				this.applyPostalCodeAttributesByCountry(countryCode, $(postalCode));
			}
		});
	},

	onCountryChange: function (event) {
		var $country = event.target;

		var eventSearchPostalCodeSelectorText = "[data-component='textInput'][data-code-type='postalCode'] input";
		var $postalCode = AccountFormHelper.getParentForm($country).find(`[data-component='accountAddressPostalCode'], ${eventSearchPostalCodeSelectorText}`);

		this.applyPostalCodeAttributesByCountry($country.value, $postalCode);
	},

	applyPostalCodeAttributesByCountry: function (country, $postalCode) {
		var formatRegex = this.postalCodeFormatWizard[`${country}PostalCodeFormat`];
		var isPostalCodeNumeric = this.postalCodeFormatWizard[`${country}IsPostalCodeNumeric`];
		var errorMessage = this.postalCodeFormatWizard[`${country}PostalCodeFormatErrorMessage`];
		var isEventSearchFormPostalCode = $postalCode.closest("[data-component='eventSearchForm']").length > 0;

		if (!isEventSearchFormPostalCode) {
			if (country === "US" || country === "USA" || country === "CA" || country === "CAN") {
				$postalCode.attr("required", true);
			} else if (!$postalCode.attr("isRequiredByDefault")) {
				$postalCode.removeAttr("required");
				$postalCode.trigger("change");
			}

			if (formatRegex) {
				$postalCode.attr("pattern", formatRegex);
				$postalCode.attr("title", errorMessage);
			} else {
				$postalCode.removeAttr("pattern");
				$postalCode.removeAttr("title");
				$postalCode.trigger("change");
			}
		}

		if (isPostalCodeNumeric) {
			$postalCode.attr("inputmode", "numeric");
		} else {
			$postalCode.removeAttr("inputmode");
		}

		$postalCode.attr("autocomplete", "postal-code");
	}
};

module.exports = PostalCodeHelper;
